import { SegmentedControl } from "@mantine/core";
import IconStarFilled from "@src/assets/icons/tabler/star-filled.svg?react";
import IconStar from "@src/assets/icons/tabler/star.svg?react";
import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import clsx from "clsx";

export type NavTreeTab = "pinned" | "workspace" | "shared";

interface NavSectionTabsProps {
	activeTab: NavTreeTab;
	onTabChange: (tab: NavTreeTab) => void;
}

export function NavSectionTabs({
	activeTab,
	onTabChange,
}: NavSectionTabsProps) {
	const isPinned = activeTab === "pinned";

	return (
		<div className="flex items-center gap-1 px-3">
			<SegmentedControl
				value={isPinned ? "" : activeTab}
				onChange={(val) => onTabChange(val as NavTreeTab)}
				size="xs"
				radius="md"
				fullWidth
				data={[
					{ label: "My Assets", value: "workspace" },
					{ label: "Shared with me", value: "shared" },
				]}
				className="bg-surface-subtle flex-1"
			/>

			<Tooltip label="Pinned" openDelay={300} withArrow>
				<button
					type="button"
					aria-label="Pinned"
					aria-pressed={isPinned}
					onClick={() => onTabChange("pinned")}
					className={clsx(
						"flex shrink-0 items-center justify-center",
						"h-8 w-8 rounded-lg transition-colors",
						isPinned
							? "bg-amber-500 text-white"
							: "bg-surface-subtle text-text-secondary hover:text-text-primary hover:bg-surface-hover-subtle",
					)}
				>
					{isPinned ? (
						<IconStarFilled width={13} height={13} />
					) : (
						<IconStar width={13} height={13} />
					)}
				</button>
			</Tooltip>
		</div>
	);
}
